export default "__VITE_ASSET__3dapnZyS__"